module.exports = __webpack_public_path__ + "static/wonder-wheel-9e471abc5576ca311884ace682f4f0e6.jpg";